import { Icon } from '@eventbrite/eds-icon';
import { InfoChunky } from '@eventbrite/eds-iconography';
import React from 'react';
import './SalesEndedMessage.scss';

export interface SalesEndedMessageProps {
    shouldShowSalesEndedMessage: boolean;
    organizerSalesEndedMessage: string | null;
    salesEndedMessage: string | null;
}

export const SalesEndedMessage = ({
    shouldShowSalesEndedMessage,
    organizerSalesEndedMessage,
    salesEndedMessage,
}: SalesEndedMessageProps) => (
    <>
        {shouldShowSalesEndedMessage && (
            <div className="sales-ended-message">
                <div className="sales-ended-message__icon">
                    <Icon type={<InfoChunky />} isBlockLevel={true} />
                </div>
                <div className="sales-ended-message__content">
                    <h2 className="sales-ended-message__title">
                        {salesEndedMessage}
                    </h2>
                    <p className="sales-ended-message__text">
                        {organizerSalesEndedMessage}
                    </p>
                </div>
            </div>
        )}
    </>
);
